import { RecordDeliverableDestination, RecordDeliverableFormat, RecordStartTrigger } from "@modules/records/types/record";
import { ServerTemplate } from "./server-template";

export class Project {
  id?: string;
  name?: string;
  photoUrl?: string;
  startTrigger?: {            // Optional object to identify what will start recod. If ommited startTime will be used.
    type: RecordStartTrigger,
    value?: string;            // Only applicable for timecode trigger.
  } = {type: 'manual', value: ''};
  serverTemplates?: ServerTemplate[];
  destinations?: {[key: string]: {bucket: string, profile: string, name?: string, acl: string}};
  settings?: {
    slackNotificationError?: string[],
    slackNotificationStart?: string[],
    slackNotificationFinish?: string[],
    slackNotificationRecordCreated?: string[],
    slackNotificationServerStarted?: string[],
  }
}